//@ts-nocheck
import { Coin } from "../../../cosmos/base/v1beta1/coin";
import { BinaryReader, BinaryWriter } from "../../../binary";
import { isSet } from "../../../helpers";
import { GlobalDecoderRegistry } from "../../../registry";
function createBaseMsgDelegate() {
    return {
        creator: "",
        validator: "",
        provider: "",
        chainID: "",
        amount: Coin.fromPartial({})
    };
}
export const MsgDelegate = {
    typeUrl: "/lavanet.lava.dualstaking.MsgDelegate",
    aminoType: "dualstaking/Delegate",
    is(o) {
        return o && (o.$typeUrl === MsgDelegate.typeUrl || typeof o.creator === "string" && typeof o.validator === "string" && typeof o.provider === "string" && typeof o.chainID === "string" && Coin.is(o.amount));
    },
    isSDK(o) {
        return o && (o.$typeUrl === MsgDelegate.typeUrl || typeof o.creator === "string" && typeof o.validator === "string" && typeof o.provider === "string" && typeof o.chainID === "string" && Coin.isSDK(o.amount));
    },
    isAmino(o) {
        return o && (o.$typeUrl === MsgDelegate.typeUrl || typeof o.creator === "string" && typeof o.validator === "string" && typeof o.provider === "string" && typeof o.chainID === "string" && Coin.isAmino(o.amount));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.validator !== "") {
            writer.uint32(42).string(message.validator);
        }
        if (message.provider !== "") {
            writer.uint32(18).string(message.provider);
        }
        if (message.chainID !== "") {
            writer.uint32(26).string(message.chainID);
        }
        if (message.amount !== undefined) {
            Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 5:
                    message.validator = reader.string();
                    break;
                case 2:
                    message.provider = reader.string();
                    break;
                case 3:
                    message.chainID = reader.string();
                    break;
                case 4:
                    message.amount = Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            creator: isSet(object.creator) ? String(object.creator) : "",
            validator: isSet(object.validator) ? String(object.validator) : "",
            provider: isSet(object.provider) ? String(object.provider) : "",
            chainID: isSet(object.chainID) ? String(object.chainID) : "",
            amount: isSet(object.amount) ? Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.validator !== undefined && (obj.validator = message.validator);
        message.provider !== undefined && (obj.provider = message.provider);
        message.chainID !== undefined && (obj.chainID = message.chainID);
        message.amount !== undefined && (obj.amount = message.amount ? Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgDelegate();
        message.creator = object.creator ?? "";
        message.validator = object.validator ?? "";
        message.provider = object.provider ?? "";
        message.chainID = object.chainID ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? Coin.fromPartial(object.amount) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgDelegate();
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        if (object.validator !== undefined && object.validator !== null) {
            message.validator = object.validator;
        }
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = Coin.fromAmino(object.amount);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.creator = message.creator === "" ? undefined : message.creator;
        obj.validator = message.validator === "" ? undefined : message.validator;
        obj.provider = message.provider === "" ? undefined : message.provider;
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        obj.amount = message.amount ? Coin.toAmino(message.amount) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return MsgDelegate.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "dualstaking/Delegate",
            value: MsgDelegate.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgDelegate.decode(message.value);
    },
    toProto(message) {
        return MsgDelegate.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.dualstaking.MsgDelegate",
            value: MsgDelegate.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(MsgDelegate.typeUrl, MsgDelegate);
GlobalDecoderRegistry.registerAminoProtoMapping(MsgDelegate.aminoType, MsgDelegate.typeUrl);
function createBaseMsgDelegateResponse() {
    return {};
}
export const MsgDelegateResponse = {
    typeUrl: "/lavanet.lava.dualstaking.MsgDelegateResponse",
    is(o) {
        return o && o.$typeUrl === MsgDelegateResponse.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === MsgDelegateResponse.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === MsgDelegateResponse.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgDelegateResponse();
        return message;
    },
    fromAmino(_) {
        const message = createBaseMsgDelegateResponse();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return MsgDelegateResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return MsgDelegateResponse.decode(message.value);
    },
    toProto(message) {
        return MsgDelegateResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.dualstaking.MsgDelegateResponse",
            value: MsgDelegateResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(MsgDelegateResponse.typeUrl, MsgDelegateResponse);
function createBaseMsgRedelegate() {
    return {
        creator: "",
        fromProvider: "",
        toProvider: "",
        fromChainID: "",
        toChainID: "",
        amount: Coin.fromPartial({})
    };
}
export const MsgRedelegate = {
    typeUrl: "/lavanet.lava.dualstaking.MsgRedelegate",
    aminoType: "dualstaking/Redelegate",
    is(o) {
        return o && (o.$typeUrl === MsgRedelegate.typeUrl || typeof o.creator === "string" && typeof o.fromProvider === "string" && typeof o.toProvider === "string" && typeof o.fromChainID === "string" && typeof o.toChainID === "string" && Coin.is(o.amount));
    },
    isSDK(o) {
        return o && (o.$typeUrl === MsgRedelegate.typeUrl || typeof o.creator === "string" && typeof o.from_provider === "string" && typeof o.to_provider === "string" && typeof o.from_chainID === "string" && typeof o.to_chainID === "string" && Coin.isSDK(o.amount));
    },
    isAmino(o) {
        return o && (o.$typeUrl === MsgRedelegate.typeUrl || typeof o.creator === "string" && typeof o.from_provider === "string" && typeof o.to_provider === "string" && typeof o.from_chainID === "string" && typeof o.to_chainID === "string" && Coin.isAmino(o.amount));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.fromProvider !== "") {
            writer.uint32(18).string(message.fromProvider);
        }
        if (message.toProvider !== "") {
            writer.uint32(26).string(message.toProvider);
        }
        if (message.fromChainID !== "") {
            writer.uint32(34).string(message.fromChainID);
        }
        if (message.toChainID !== "") {
            writer.uint32(42).string(message.toChainID);
        }
        if (message.amount !== undefined) {
            Coin.encode(message.amount, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRedelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.fromProvider = reader.string();
                    break;
                case 3:
                    message.toProvider = reader.string();
                    break;
                case 4:
                    message.fromChainID = reader.string();
                    break;
                case 5:
                    message.toChainID = reader.string();
                    break;
                case 6:
                    message.amount = Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            creator: isSet(object.creator) ? String(object.creator) : "",
            fromProvider: isSet(object.fromProvider) ? String(object.fromProvider) : "",
            toProvider: isSet(object.toProvider) ? String(object.toProvider) : "",
            fromChainID: isSet(object.fromChainID) ? String(object.fromChainID) : "",
            toChainID: isSet(object.toChainID) ? String(object.toChainID) : "",
            amount: isSet(object.amount) ? Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.fromProvider !== undefined && (obj.fromProvider = message.fromProvider);
        message.toProvider !== undefined && (obj.toProvider = message.toProvider);
        message.fromChainID !== undefined && (obj.fromChainID = message.fromChainID);
        message.toChainID !== undefined && (obj.toChainID = message.toChainID);
        message.amount !== undefined && (obj.amount = message.amount ? Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgRedelegate();
        message.creator = object.creator ?? "";
        message.fromProvider = object.fromProvider ?? "";
        message.toProvider = object.toProvider ?? "";
        message.fromChainID = object.fromChainID ?? "";
        message.toChainID = object.toChainID ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? Coin.fromPartial(object.amount) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgRedelegate();
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        if (object.from_provider !== undefined && object.from_provider !== null) {
            message.fromProvider = object.from_provider;
        }
        if (object.to_provider !== undefined && object.to_provider !== null) {
            message.toProvider = object.to_provider;
        }
        if (object.from_chainID !== undefined && object.from_chainID !== null) {
            message.fromChainID = object.from_chainID;
        }
        if (object.to_chainID !== undefined && object.to_chainID !== null) {
            message.toChainID = object.to_chainID;
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = Coin.fromAmino(object.amount);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.creator = message.creator === "" ? undefined : message.creator;
        obj.from_provider = message.fromProvider === "" ? undefined : message.fromProvider;
        obj.to_provider = message.toProvider === "" ? undefined : message.toProvider;
        obj.from_chainID = message.fromChainID === "" ? undefined : message.fromChainID;
        obj.to_chainID = message.toChainID === "" ? undefined : message.toChainID;
        obj.amount = message.amount ? Coin.toAmino(message.amount) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return MsgRedelegate.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "dualstaking/Redelegate",
            value: MsgRedelegate.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgRedelegate.decode(message.value);
    },
    toProto(message) {
        return MsgRedelegate.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.dualstaking.MsgRedelegate",
            value: MsgRedelegate.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(MsgRedelegate.typeUrl, MsgRedelegate);
GlobalDecoderRegistry.registerAminoProtoMapping(MsgRedelegate.aminoType, MsgRedelegate.typeUrl);
function createBaseMsgRedelegateResponse() {
    return {};
}
export const MsgRedelegateResponse = {
    typeUrl: "/lavanet.lava.dualstaking.MsgRedelegateResponse",
    is(o) {
        return o && o.$typeUrl === MsgRedelegateResponse.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === MsgRedelegateResponse.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === MsgRedelegateResponse.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRedelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgRedelegateResponse();
        return message;
    },
    fromAmino(_) {
        const message = createBaseMsgRedelegateResponse();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return MsgRedelegateResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return MsgRedelegateResponse.decode(message.value);
    },
    toProto(message) {
        return MsgRedelegateResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.dualstaking.MsgRedelegateResponse",
            value: MsgRedelegateResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(MsgRedelegateResponse.typeUrl, MsgRedelegateResponse);
function createBaseMsgUnbond() {
    return {
        creator: "",
        validator: "",
        provider: "",
        chainID: "",
        amount: Coin.fromPartial({})
    };
}
export const MsgUnbond = {
    typeUrl: "/lavanet.lava.dualstaking.MsgUnbond",
    aminoType: "dualstaking/Unbond",
    is(o) {
        return o && (o.$typeUrl === MsgUnbond.typeUrl || typeof o.creator === "string" && typeof o.validator === "string" && typeof o.provider === "string" && typeof o.chainID === "string" && Coin.is(o.amount));
    },
    isSDK(o) {
        return o && (o.$typeUrl === MsgUnbond.typeUrl || typeof o.creator === "string" && typeof o.validator === "string" && typeof o.provider === "string" && typeof o.chainID === "string" && Coin.isSDK(o.amount));
    },
    isAmino(o) {
        return o && (o.$typeUrl === MsgUnbond.typeUrl || typeof o.creator === "string" && typeof o.validator === "string" && typeof o.provider === "string" && typeof o.chainID === "string" && Coin.isAmino(o.amount));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.validator !== "") {
            writer.uint32(42).string(message.validator);
        }
        if (message.provider !== "") {
            writer.uint32(18).string(message.provider);
        }
        if (message.chainID !== "") {
            writer.uint32(26).string(message.chainID);
        }
        if (message.amount !== undefined) {
            Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUnbond();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 5:
                    message.validator = reader.string();
                    break;
                case 2:
                    message.provider = reader.string();
                    break;
                case 3:
                    message.chainID = reader.string();
                    break;
                case 4:
                    message.amount = Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            creator: isSet(object.creator) ? String(object.creator) : "",
            validator: isSet(object.validator) ? String(object.validator) : "",
            provider: isSet(object.provider) ? String(object.provider) : "",
            chainID: isSet(object.chainID) ? String(object.chainID) : "",
            amount: isSet(object.amount) ? Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.validator !== undefined && (obj.validator = message.validator);
        message.provider !== undefined && (obj.provider = message.provider);
        message.chainID !== undefined && (obj.chainID = message.chainID);
        message.amount !== undefined && (obj.amount = message.amount ? Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUnbond();
        message.creator = object.creator ?? "";
        message.validator = object.validator ?? "";
        message.provider = object.provider ?? "";
        message.chainID = object.chainID ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? Coin.fromPartial(object.amount) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgUnbond();
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        if (object.validator !== undefined && object.validator !== null) {
            message.validator = object.validator;
        }
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = Coin.fromAmino(object.amount);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.creator = message.creator === "" ? undefined : message.creator;
        obj.validator = message.validator === "" ? undefined : message.validator;
        obj.provider = message.provider === "" ? undefined : message.provider;
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        obj.amount = message.amount ? Coin.toAmino(message.amount) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return MsgUnbond.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "dualstaking/Unbond",
            value: MsgUnbond.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgUnbond.decode(message.value);
    },
    toProto(message) {
        return MsgUnbond.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.dualstaking.MsgUnbond",
            value: MsgUnbond.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(MsgUnbond.typeUrl, MsgUnbond);
GlobalDecoderRegistry.registerAminoProtoMapping(MsgUnbond.aminoType, MsgUnbond.typeUrl);
function createBaseMsgUnbondResponse() {
    return {};
}
export const MsgUnbondResponse = {
    typeUrl: "/lavanet.lava.dualstaking.MsgUnbondResponse",
    is(o) {
        return o && o.$typeUrl === MsgUnbondResponse.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === MsgUnbondResponse.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === MsgUnbondResponse.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUnbondResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUnbondResponse();
        return message;
    },
    fromAmino(_) {
        const message = createBaseMsgUnbondResponse();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return MsgUnbondResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return MsgUnbondResponse.decode(message.value);
    },
    toProto(message) {
        return MsgUnbondResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.dualstaking.MsgUnbondResponse",
            value: MsgUnbondResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(MsgUnbondResponse.typeUrl, MsgUnbondResponse);
function createBaseMsgClaimRewards() {
    return {
        creator: "",
        provider: ""
    };
}
export const MsgClaimRewards = {
    typeUrl: "/lavanet.lava.dualstaking.MsgClaimRewards",
    aminoType: "dualstaking/MsgClaimRewards",
    is(o) {
        return o && (o.$typeUrl === MsgClaimRewards.typeUrl || typeof o.creator === "string" && typeof o.provider === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === MsgClaimRewards.typeUrl || typeof o.creator === "string" && typeof o.provider === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === MsgClaimRewards.typeUrl || typeof o.creator === "string" && typeof o.provider === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.provider !== "") {
            writer.uint32(18).string(message.provider);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgClaimRewards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.provider = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            creator: isSet(object.creator) ? String(object.creator) : "",
            provider: isSet(object.provider) ? String(object.provider) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.provider !== undefined && (obj.provider = message.provider);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgClaimRewards();
        message.creator = object.creator ?? "";
        message.provider = object.provider ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgClaimRewards();
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.creator = message.creator === "" ? undefined : message.creator;
        obj.provider = message.provider === "" ? undefined : message.provider;
        return obj;
    },
    fromAminoMsg(object) {
        return MsgClaimRewards.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "dualstaking/MsgClaimRewards",
            value: MsgClaimRewards.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgClaimRewards.decode(message.value);
    },
    toProto(message) {
        return MsgClaimRewards.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.dualstaking.MsgClaimRewards",
            value: MsgClaimRewards.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(MsgClaimRewards.typeUrl, MsgClaimRewards);
GlobalDecoderRegistry.registerAminoProtoMapping(MsgClaimRewards.aminoType, MsgClaimRewards.typeUrl);
function createBaseMsgClaimRewardsResponse() {
    return {};
}
export const MsgClaimRewardsResponse = {
    typeUrl: "/lavanet.lava.dualstaking.MsgClaimRewardsResponse",
    is(o) {
        return o && o.$typeUrl === MsgClaimRewardsResponse.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === MsgClaimRewardsResponse.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === MsgClaimRewardsResponse.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgClaimRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgClaimRewardsResponse();
        return message;
    },
    fromAmino(_) {
        const message = createBaseMsgClaimRewardsResponse();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return MsgClaimRewardsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return MsgClaimRewardsResponse.decode(message.value);
    },
    toProto(message) {
        return MsgClaimRewardsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.dualstaking.MsgClaimRewardsResponse",
            value: MsgClaimRewardsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(MsgClaimRewardsResponse.typeUrl, MsgClaimRewardsResponse);
